import { stepTracker } from '../stepTracker'
import { type TrackedChangesCommandHandler } from './types'

export const splitListItemOnGapCursor: TrackedChangesCommandHandler = ({
  originalTr,
  wrappedTr,
  map,
  state,
  userId,
}) => {
  stepTracker({ originalTr, wrappedTr, map, state, userId })
  return true
}
